import { InputField, Paragraph } from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';
import { AutoCompleteContainer, OptionsContainer } from './Autocomplete.styles';
import React from 'react';
import { FiPlus } from 'react-icons/fi';
import { ExamProps } from '../../FormRisk.types';
import { useAutocomplete } from './Autocomplete.hooks';

type AutocompleteProps = {
	onAddExam: (exam: ExamProps) => void;
};

export const Autocomplete = ({ onAddExam }: AutocompleteProps) => {
	const {
		loading,
		selected,
		suggestions,
		searchString,
		optionsVisible,
		handleSelect,
		handleFocus,
		handleAddExam,
		setSearchString,
	} = useAutocomplete({ onAddExam });

	return (
		<AutoCompleteContainer>
			<div>
				<InputField
					type="query"
					data-testid="search-exam"
					label="Búsqueda de estudios"
					placeholder="Escribe el nombre del estudio"
					loading={loading}
					value={searchString}
					onChange={setSearchString}
					onFocus={handleFocus}
				/>
				{optionsVisible && (
					<OptionsContainer data-testid="search-exam-options">
						{suggestions.map((suggestion) => (
							<Paragraph
								fontWeight="500"
								key={suggestion.id}
								padding="10px 15px"
								data-testid={`suggestion-${suggestion.id}`}
								onClick={() => handleSelect(suggestion)}
							>
								{suggestion.name}
							</Paragraph>
						))}
					</OptionsContainer>
				)}
			</div>
			<Button
				width="40px"
				data-testid="exam-add-button"
				disabled={!selected.id}
				onClick={handleAddExam}
			>
				<FiPlus color="white" />
			</Button>
		</AutoCompleteContainer>
	);
};
